import React from 'react'
import {
  Box,
  Grid,
  RadioGroup,
  FormControl,
  FormHelperText,
  FormControlLabel,
  Radio,
} from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'

import { AutocompleteTypeAndSearch } from 'components'
import useStyles from './styles'
import useFetch from 'hooks/useFetch'
import * as service from 'service'
import constants from 'constants/index'

const CookiesTagsForm = () => {
  const { control, watch, errors, clearError } = useFormContext()
  const reportSelected = watch('reportSelected')
  const classes = useStyles()

  // Buscar lista de banners para o autocomplete
  const { response: bannersResponse } = useFetch(
    service.cookies.banner.get,
    {},
    [],
  )
  const banners = bannersResponse?.data?.banners || []

  return (
    <Grid item xs={12}>
      <FormControl component="fieldset" error={!!errors.reportSelected}>
        <Controller
          name="reportSelected"
          control={control}
          defaultValue=""
          as={
            <RadioGroup>
              <FormControlLabel
                value={constants.cookies.reports.REPORT_TYPES.COMPLETE}
                control={<Radio classes={{ checked: classes.checked }} />}
                className={classes.radioLabel}
                label="Relatório completo"
              />
              <FormControlLabel
                value={constants.cookies.reports.REPORT_TYPES.BY_BANNER}
                control={<Radio classes={{ checked: classes.checked }} />}
                className={classes.radioLabel}
                label="Relatório por banner"
              />
            </RadioGroup>
          }
          onChange={([e]) => {
            clearError('reportSelected')
            return e.target.value
          }}
        />
        {!!errors.reportSelected && (
          <FormHelperText error={!!errors.reportSelected}>
            {errors.reportSelected.message}
          </FormHelperText>
        )}
      </FormControl>

      {reportSelected === constants.cookies.reports.REPORT_TYPES.BY_BANNER && (
        <Box mt={1}>
          <form id="cookies-tags-form">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <AutocompleteTypeAndSearch
                  name="bannerIds"
                  requestToLoadOptions={async (term) => {
                    if (!term || term.length < 3) return []
                    return banners.filter((banner) =>
                      banner.name?.toLowerCase().includes(term.toLowerCase()),
                    )
                  }}
                  textField={{
                    label: 'Nome do banner',
                    variant: 'outlined',
                    error: !!errors.bannerIds,
                    helperText: errors?.bannerIds?.message,
                  }}
                  multiple
                />
              </Grid>
            </Grid>
          </form>
        </Box>
      )}
    </Grid>
  )
}

export default CookiesTagsForm
